import React from 'react';
import { useAuthStore } from '../../stores/auth';
import { UserRole } from '../../types/enums'; // Correct import path for UserRole
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingSpinner } from '../ui/LoadingSpinner';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: UserRole[];
}

export const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children, allowedRoles }) => {
  const { user, isLoading, isAuthenticated } = useAuthStore();
  const location = useLocation();
  const redirectAfterAuth = `${location.pathname}${location.search}`;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to={`/auth?redirectAfterAuth=${encodeURIComponent(redirectAfterAuth)}`}
        replace
      />
    );
  }

  if (!allowedRoles.includes(user.role)) {
    // Optionally, redirect to a forbidden page or home
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
